import z from 'zod';

export const notificationTypeEnumSchema = z.enum([
  'system',
  'info',
  'warning',
  'error',
  'success',
  'update',
  'reminder',
  'alert',
  'maintenance',
]);

export type NotificationTypeEnum = z.infer<typeof notificationTypeEnumSchema>;
